import { Redirect, Route, Switch } from "wouter"
import { Header } from "./components/header/Header"
import { Tasks } from "./pages/main/dashboard/Tasks"
import { ProjectView } from "./pages/main/projectView/ProjectView"
import { OpenProjectView } from "./pages/main/projectView/OpenProject"
import { ViewTask } from "./pages/main/projectView/task/ViewTask"
import { FeatureProvider } from "./providers/FeatureProvider"
import { UserView } from "./pages/main/user/UserView"
import { Worksheet } from "./pages/main/user/Worksheet"
import { AuthWrapper } from "./pages/auth"
import { AdminRoot } from "./pages/admin"
import { MessagesProvider } from "./providers/MessagesProvider"
import { Notifications } from "./pages/main/notifications"

export const App = () => {
  // is logged in
  return (
    <AuthWrapper>
      <MessagesProvider>
        <FeatureProvider />
        <Header />
        <div
          style={{
            background: "#8c5fec",
            color: "#fff",
            padding: "10px 16px",
            fontSize: "14px",
            lineHeight: 1.4,
            textAlign: "center",
            whiteSpace: "pre-line",
          }}
        >
          {"Sitēma tiek migrēta uz jaunu platformu. No 1.jūnijā būs pieejama šeit: "}
          <a
            href="https://app.progresful.com"
            style={{
              color: "#fff",
              textDecoration: "underline",
              fontWeight: 700,
            }}
          >
            https://app.progresful.com
          </a>
          {"\nIzmanto jau eksistējošo lietotājvārdu/epastu un paroli."}
        </div>
        <Switch>
          <Route path="/admin/dashboard" component={AdminRoot} nest />
          <div
            style={{
              padding: "0 16px 60px",
              maxWidth: "800px",
              margin: "0 auto",
              height: "calc(100% - 54px)",
            }}
          >
            <Route path="/" component={Tasks} />
            <Route path="/me" component={UserView} />
            <Route path="/me/worksheet" component={Worksheet} />
            <Route path="/notifications" component={Notifications} />
            <Route path="/dashboard" component={Tasks} />
            <Route path="/dashboard/project/:id" component={ProjectView} />
            <Route
              path="/dashboard/project/:projId/:subId"
              component={OpenProjectView}
            />
            <Route
              path="/dashboard/project/:projId/:subId/:taskId"
              component={ViewTask}
            />
          </div>
          <Redirect to="/dashboard" />
          <Route>404</Route>
        </Switch>
      </MessagesProvider>
    </AuthWrapper>
  )
}
